import { MarketGroupsModel } from "../model";
export class MarketGroupsMapper {
    map(marketData, leagueId) {
        return new MarketGroupsModel(marketData, leagueId);
    }
}
//# sourceMappingURL=MarketGroupsMapper.js.map